import { ApiError } from '@/shared/lib/api/api-client'

/** Failure codes `PUT /api/Accounts` answers with (th_saas CU-93). */
export const AccountUpdateErrorCode = {
  ConnectivityChangeNotAllowed: 'ACCOUNT_CONNECTIVITY_CHANGE_NOT_ALLOWED',
} as const

export type AccountUpdateErrorCode = (typeof AccountUpdateErrorCode)[keyof typeof AccountUpdateErrorCode]

export interface AccountUpdateError {
  /** Null when the failure carried no body or a code this screen does not know. */
  code: AccountUpdateErrorCode | null
  /** The backend's English text, used when the code has no translation. */
  message: string | null
}

const KNOWN_CODES: readonly string[] = Object.values(AccountUpdateErrorCode)

function isKnownCode(value: unknown): value is AccountUpdateErrorCode {
  return typeof value === 'string' && KNOWN_CODES.includes(value)
}

/** Reads the `{ errorCode, message }` body of a failed update. */
export function readAccountUpdateError(error: unknown): AccountUpdateError {
  if (!(error instanceof ApiError) || !error.details) {
    return { code: null, message: null }
  }

  const { errorCode, message } = error.details
  return {
    code: isKnownCode(errorCode) ? errorCode : null,
    message: typeof message === 'string' && message.length > 0 ? message : null,
  }
}
